import React from "react";
import "../styles/benefits-section.scss";

const enterpriseBenefits = [
  {
    title: "Access to Wider Skills & Expertise",
    text: "Instant access to a robust network of complementary expertise, niche specialists, and proven resources—eliminating the overhead of internal hiring and lengthy vendor searches.",
  },
  {
    title: "Creative Problem Solving",
    text: "Leverage specialized, multi-perspective analysis of complex challenges to identify hidden risks and deliver resilient, high-impact solutions that reduce failures and maximize ROI.",
  },
  {
    title: "Continuous Agility & Long-Term Adaptation",
    text: "Stay agile and future-ready through real-time market intelligence, trend insights, peer benchmarking, and best-practice sharing—helping you respond confidently to regulatory shifts, technological disruption, and economic change.",
  },
  {
    title: "Better Innovation & Product Development",
    text: "Accelerate innovation by leveraging shared knowledge and technology to create higher-quality products and services at lower cost and reduced risk—strengthening your organisation’s competitive advantage.",
  },
];

const professionalBenefits = [
  {
    title: "Boost Your Income",
    text: "Improve your standard of living and financial security; save more and achieve your personal and professional goals.",
  },
  {
    title: "Optimal Talent Deployment",
    text: "Leverage your skills, experience, knowledge, and qualifications to take on additional roles, deliver greater impact, and accelerate your career growth.",
  },
  {
    title: "Stronger Professional Connections",
    text: "Enabled to cultivate stronger networks that provide emotional support, practical help, new leads, and a safety net.",
  },
  {
    title: "Expanded Knowledge & Fresh Perspectives",
    text: 'Engage with diverse expertise and ideas that challenge your assumptions, spark innovation, and lead to breakthrough “aha” moments.',
  },
  {
    title: "Continuous Personal & Professional Growth",
    text: "Develop new capabilities, broaden your thinking, and strengthen your expertise beyond your primary field of specialization.",
  },
];

const BenefitsSection = () => {
  return (
    <section className="benefits-section">
      <div className="container">
        <div className="benefits-section__intro">
          <p className="benefits-section__eyebrow">Why Choose Kiubunifu?</p>
          <h2 className="benefits-section__title">
            Built for both organisations in need of expert support and professionals available to provide the needed support.
          </h2>
          <p className="benefits-section__subtitle">
            Whether you are submitting a tender or joining as an affiliate, our ecosystem is designed to creatively solve complex problems, nurture talent, fuel innovation, and unlock opportunities.
          </p>
        </div>

        <div className="benefits-section__grid">
          <div className="benefits-card">
            <div className="benefits-card__header">
              <span className="benefits-card__label">For Organisations</span>
              <h3 className="benefits-card__title">
                Trust us to support you through your challenges
              </h3>
              <p className="benefits-card__text">
                Access specialized expertise, reduce execution risk, and strengthen your ability to
                innovate and adapt.
              </p>
            </div>

            <div className="benefits-card__items">
              {enterpriseBenefits.map((item, index) => (
                <div className="benefit-item" key={index}>
                  <h4 className="benefit-item__title">{item.title}</h4>
                  <p className="benefit-item__text">{item.text}</p>
                </div>
              ))}
            </div>

            <a href="#hero-professional-cta" className="benefits-card__welcome-link">
  To unlock these benefits and more, click the sign-up button above
  <span className="benefits-card__welcome-arrow" aria-hidden="true"> ↑</span>
</a>
          </div>

          <div className="benefits-card">
            <div className="benefits-card__header">
              <span className="benefits-card__label">For Professionals</span>
              <h3 className="benefits-card__title">
                Become part of our multidisciplinary community
              </h3>
              <p className="benefits-card__text">
                Grow your income, expand your network, and unlock new opportunities through meaningful
                collaboration.
              </p>
            </div>

            <div className="benefits-card__items">
              {professionalBenefits.map((item, index) => (
                <div className="benefit-item" key={index}>
                  <h4 className="benefit-item__title">{item.title}</h4>
                  <p className="benefit-item__text">{item.text}</p>
                </div>
              ))}
            </div>

            <a href="#hero-professional-cta" className="benefits-card__welcome-link">
  To unlock these benefits and more, click the sign-up button above
  <span className="benefits-card__welcome-arrow" aria-hidden="true"> ↑</span>
</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;